import iconsSvg from '@assets/images/icons.svg';
import { HawkSearchComponents, IconComponentConfig, IconComponentModel, IconName } from '@models';
import { BaseComponent } from '../../base.component';
import defaultHtml from './icon.component.hbs';

export class IconComponent extends BaseComponent<IconComponentConfig, never, IconComponentModel> {
    protected override componentName: keyof HawkSearchComponents = 'icon';
    protected override defaultHtml = defaultHtml;
    protected override bindFromEvent = false;

    private get name(): IconName | undefined {
        return (this.getAttribute('name') as IconName) ?? undefined;
    }

    private get size(): string {
        const size = this.getAttribute('size');

        if (!size) {
            return '1em';
        }

        if (isNaN(Number(size))) {
            return size;
        }

        return `${size}px`;
    }

    protected override renderContent(): boolean {
        return !!this.name;
    }

    protected override getContentModel(): IconComponentModel {
        const svg = (iconsSvg as string).replace(
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">',
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: none;">'
        );

        return {
            svg: svg,
            url: `#${this.name}`,
            height: this.size,
            width: this.size
        };
    }
}
